import {style} from 'typestyle'
import * as csstips from 'csstips'

export const youXuanType = style({
    top: 2,
    position: 'relative',
    marginRight: 4,
    height: 16,
    width: 35,
    display: 'inline-block'
})

export const HomeCardViewItemFreeText = style({
    fontWeight: 500
})

export const cardViewWrap = style({
    width: '44.53vw',
    maxWidth: 216,
    display: 'inline-block',
    marginBottom: 15
})

export const cardViewItem = style({
      background: 'rgba(255,255,255,1)',
      position: 'relative',
      boxShadow: '0 5px 8px 0 rgba(51,51,51,0.05)',
      borderRadius: 8,
      $nest: {
          '&:active': {
              background: '#f8f8f8'
          }
      }
    //   $nest: {
    //     '&::before': {
    //         'content': `" "`,
    //         'border': '1px solid #E1E1E1',
    //         'position': 'absolute',
    //         'width': '200%',
    //         'height': '200%',
    //         'transform': 'scale(0.5, 0.5)',
    //         'transformOrigin': '0 0',
    //         'boxSizing': 'border-box',
    //         'borderRadius': 8,
    //         '-webkitTransform': 'scale(0.5, 0.5)',
    //         '-webkit-transform-origin': '0 0'
    //   }
    // }
})

export const Cover = style({
    position: 'relative',
    width: '100%',
    maxWidth: '100%',
    margin: '0 auto',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: '22.9333vw',
    overflow: 'hidden',
    maxHeight: 120,
    $nest: {
        '& img': {
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3,
            position: 'relative'
        }
    }
})

export const contentArea = style({
    padding: '8px 10px 10px 10px'
})

export const titleArea = style({
    fontSize: 16,
    color: '#333333',
    lineHeight: '18px',
    marginBottom: 13,
    height: 36,
    fontWeight: 500,
    $nest: {
       '& .tags': {
            position: 'relative'
       }
    }
})

export const PriceArea = style({
    ...csstips.flexRoot,
    '-webkit-align-items': 'baseline',
    '-ms-flex-align': 'baseline',
    'alignItems': 'baseline',
    'lineHeight': '0',
    'marginTop': '10px'
})

export const realPrice = style({
    fontSize: 14,
    fontWeight: 500,
    color: 'rgba(244,67,54,1)',
    $nest: {
        '& i': {
            height: 12,
            fontSize: 12,
            fontWeight: 500,
            color: 'rgba(244,67,54,1)',
            lineHeight: '12px',
            fontStyle: 'normal',
            marginRight: 3
        },
        '& span': {
            display: 'inline-block',
            height: 12,
            fontWeight: 500,
            color: 'rgba(244,67,54,1)',
            lineHeight: '12px',
            fontSize: 12
        }
    }
})

export const originPrice = style({
    marginLeft: 5,
    textDecoration: 'line-through',
    height: 10,
    fontSize: 10,
    fontWeight: 400,
    color: 'rgba(153,153,153,1)',
    lineHeight: '10px'
})

export const cardViewBottom = style({
    ...csstips.flexRoot,
    ...csstips.betweenJustified,
    position: 'relative',
    marginTop: 5
})

export const itemStatus = style({
    height: 10,
    fontSize: 10,
    fontWeight: 400,
    color: '#999999',
    lineHeight: '10px',
    $nest: {
        '& p': {
            fontSize: 12,
            fontWeight: 400,
            color: '#999999',
            lineHeight: '12px'
        }
    }
})

export const studyNum = style({
    height: 10,
    fontSize: 10,
    fontWeight: 400,
    color: 'rgba(153,153,153,1)',
    lineHeight: '10px'
})

export const CoverStyle = style({
    height: '100%',
    overflow: 'hidden'
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeCardView/HomeCardViewItem.style.ts